import {
  FETCH_TEAMS,
  FETCH_TEAMS_SUCCESS,
  FETCH_TEAMS_ERROR,
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: [],
  loading: false,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case FETCH_TEAMS:
      return {
        ...state,
        data: null,
        loading: true,
        error: null,
      }
    case FETCH_TEAMS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    case FETCH_TEAMS_ERROR:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload
      }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/myTeamsReducer.js